import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useContext } from 'react';
import { PermissionsModalContext } from '../../../contexts/PermissionModalContext';
import { useTranslation } from '../../../contexts/TranslationContext';
import { MHMTypography } from '../MHM/MHMTypography';
import { MHMButton } from '../MHM/MHMButton';

export function PermissionsModal() {
  const { isPermissionModalOpen, closePermissionsModal } = useContext(
    PermissionsModalContext,
  );
  const { t } = useTranslation();

  return (
    <Dialog open={isPermissionModalOpen} onClose={closePermissionsModal}>
      <DialogTitle>{t('Insufficient Permissions')}</DialogTitle>
      <DialogContent>
        <MHMTypography>
          {t(
            'You do not have the necessary permissions to modify this setting',
          )}
          <br />
          {t('Please contact your administrator')}
        </MHMTypography>
      </DialogContent>
      <DialogActions>
        <MHMButton autoFocus onClick={closePermissionsModal}>
          {t('Close')}
        </MHMButton>
      </DialogActions>
    </Dialog>
  );
}
